<template>
    <b-modal :id="modalId" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
        <div id="header" class="mb-2">
            <span class="title">{{ $t('enps.duplicateSearch') }}</span>
            <i class="close-button fas fa-times" @click="closeModal" />
        </div>

        <div>
            <div v-if="isLoading" class="loader">
                <Loader :loader="isLoading" />
            </div>

            <Form
                v-else
                :research="research"
                :isSubmitting="isSubmitting"
                @submit="submitHandler"
                @cancel="cancelHandler"
            />
        </div>
    </b-modal>
</template>

<script>
import { Form } from './components'
import { getResearch } from '@/views/enps/api'
import Loader from '@/views/components/loader'
import enpsMixin from '../children/enpsMixin'

export default {
    name: 'DuplicateEnpsResearch',
    components: {
        Form,
        Loader,
    },
    mixins: [enpsMixin],
    data() {
        return {
            modalId: 'duplicate-enps-research',
            isSubmitting: false,
            isLoading: true,
            research: null,
        }
    },
    computed: {
        researchId() {
            return this.$route.params.id
        },
    },
    mounted() {
        this.$bvModal.show(this.modalId)
        this.getResearchFromApi()
    },
    methods: {
        getResearchFromApi() {
            this.isLoading = true
            getResearch(this.researchId)
                .then((research) => {
                    this.research = research
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        submitHandler(data) {
            this.isSubmitting = true
            this.onSubmit(null, data, 'duplicate', 'research-created', 'new-enps-research')
            this.isSubmitting = true
        },
        cancelHandler() {
            this.closeModal()
        },
        closeModal() {
            this.$router.back()
        },
    },
}
</script>

<style lang="scss" scoped>
#header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        color: #009ada;
    }

    .close-button {
        color: #3b3f4e;
        cursor: pointer;
        font-size: 18px;
    }
}
</style>
